import { render, staticRenderFns } from "./TreatmentItemInputTable.vue?vue&type=template&id=04cd89ae&scoped=true&"
import script from "./TreatmentItemInputTable.vue?vue&type=script&lang=js&"
export * from "./TreatmentItemInputTable.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentItemInputTable.vue?vue&type=style&index=0&id=04cd89ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd89ae",
  null
  
)

export default component.exports